$sort-indicator-color: inherit !default;

/* Sortable column indicator */

.af-sort-column {
  cursor: pointer;

  &--css#{&}--ascending::before {
    content: "\25B2\00a0";
    color: $sort-indicator-color;
  }

  &--css#{&}--descending::before {
    content: "\25BC\00a0";
    color: $sort-indicator-color;
  }

  &--html#{&}--ascending .__indicator::after {
    content: "\00a0\25B2";
    color: $sort-indicator-color;
  }

  &--html#{&}--descending .__indicator::after {
    content: "\00a0\25BC";
    color: $sort-indicator-color;
  }

  &--html > .__container {
    display: flex;
    align-items: center;

    > .__content {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
